module.exports = __webpack_public_path__ + "img/standard-viewer-mini-image.9d4ec450.svg";